module.exports = __webpack_public_path__ + "staticcomp/img/share.f279224.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/10/share.jpg
// module id = fEVS
// module chunks = 39